/** @format */

const template = `
<input
  class="form-control url-input"
  name="{{::$ctrl.name}}"
  type="text"
  ng-change="$ctrl.valueChanged()"
  ng-model="$ctrl.ngModel.$viewValue"
  ng-required="$ctrl.required"
  ng-maxlength="$ctrl.maxLength"
  ng-pattern="$ctrl.pattern"
  placeholder="{{::$ctrl.placeholder}}"
  valdr-no-validate="true" />
`;
export default template;
